import { Injectable } from '@angular/core';
import { Apollo, ApolloBase, gql } from 'apollo-angular';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { LogEvent } from '../../../models/log-event';

const LOG_EVENTS_SUBSCRIPTION = gql`
  subscription {
    onLogEventAdded {
      level
      message
      tags
      timestamp
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class LogEventsService {
  private apolloHot: ApolloBase;
  private logEvents$ = new BehaviorSubject<LogEvent>({} as LogEvent); 
  private isSubscribed = false;

  constructor(private apollo: Apollo) { 
    this.apolloHot = this.apollo.use('hotchocolate');
    this.initSubscription();
  }

  private initSubscription() {
    if (this.isSubscribed) return;

    this.connect();

    this.isSubscribed = true;
  }

  // Auch die Live-Transkript-Zeilen im Details-Panel laufen über diesen Stream: nach
  // einem abgewiesenen oder verlorenen Socket neu verbinden, wie BroadcastsService.
  private connect() {
    const reconnect = () => setTimeout(() => this.connect(), 2000 + Math.random() * 2000);

    this.apolloHot.subscribe({
      query: LOG_EVENTS_SUBSCRIPTION
    }).pipe(
      map((result: any) => result?.data?.onLogEventAdded as LogEvent)
    ).subscribe({
      next: (logEvent) => this.logEvents$.next(logEvent),
      error: (err) => {
        console.error('Log subscription error:', err);
        reconnect();
      },
      complete: reconnect
    });
  }

  getLogEvents(): Observable<LogEvent> {
    return this.logEvents$.asObservable();
  }
  
  subscribeToBroadcasts() {
    return this.apolloHot.subscribe({
      query: LOG_EVENTS_SUBSCRIPTION
    });
  }
}
